/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var common_pb = require('./common_pb.js');
goog.exportSymbol('proto.ori.telecomms.proto.RouteProgress', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.RouteProgress.RouteProgressStatus', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.RouteProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ori.telecomms.proto.RouteProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.RouteProgress.displayName = 'proto.ori.telecomms.proto.RouteProgress';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.RouteProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.RouteProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.RouteProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RouteProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
    utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    percent: +jspb.Message.getFieldWithDefault(msg, 2, 0.0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    waypoints: (f = msg.getWaypoints()) && common_pb.WaypointList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.RouteProgress}
 */
proto.ori.telecomms.proto.RouteProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.RouteProgress;
  return proto.ori.telecomms.proto.RouteProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.RouteProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.RouteProgress}
 */
proto.ori.telecomms.proto.RouteProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPercent(value);
      break;
    case 3:
      var value = /** @type {!proto.ori.telecomms.proto.RouteProgress.RouteProgressStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new common_pb.WaypointList;
      reader.readMessage(value,common_pb.WaypointList.deserializeBinaryFromReader);
      msg.setWaypoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.RouteProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.RouteProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.RouteProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.RouteProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPercent();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getWaypoints();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.WaypointList.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.ori.telecomms.proto.RouteProgress.RouteProgressStatus = {
  UNKNOWN: 0,
  INACTIVE: 1,
  RUNNING: 2,
  SUCCESS: 3,
  FAILURE: 4
};

/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.ori.telecomms.proto.RouteProgress.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.ori.telecomms.proto.RouteProgress.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double percent = 2;
 * @return {number}
 */
proto.ori.telecomms.proto.RouteProgress.prototype.getPercent = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.ori.telecomms.proto.RouteProgress.prototype.setPercent = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional RouteProgressStatus status = 3;
 * @return {!proto.ori.telecomms.proto.RouteProgress.RouteProgressStatus}
 */
proto.ori.telecomms.proto.RouteProgress.prototype.getStatus = function() {
  return /** @type {!proto.ori.telecomms.proto.RouteProgress.RouteProgressStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.ori.telecomms.proto.RouteProgress.RouteProgressStatus} value */
proto.ori.telecomms.proto.RouteProgress.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional WaypointList waypoints = 4;
 * @return {?proto.ori.telecomms.proto.WaypointList}
 */
proto.ori.telecomms.proto.RouteProgress.prototype.getWaypoints = function() {
  return /** @type{?proto.ori.telecomms.proto.WaypointList} */ (
    jspb.Message.getWrapperField(this, common_pb.WaypointList, 4));
};


/** @param {?proto.ori.telecomms.proto.WaypointList|undefined} value */
proto.ori.telecomms.proto.RouteProgress.prototype.setWaypoints = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.ori.telecomms.proto.RouteProgress.prototype.clearWaypoints = function() {
  this.setWaypoints(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ori.telecomms.proto.RouteProgress.prototype.hasWaypoints = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.ori.telecomms.proto);
